import { authorizedApiClient } from "./config";

export type WorkspaceMemberIntegration = {
  id: string;
  workspace_id: string;
  workspace_member_id: string;
  integration_id: string;
  provider: string;
  external_account_id: string | null;
  primary_email: string | null;
  options?: Record<string, any> | null;
  is_active?: boolean;
  is_default_for_member?: boolean;
  created_at?: string;
  updated_at?: string;
};

export const getMemberIntegrationsMe = async ({
  workspace_id,
}: { workspace_id: string }) => authorizedApiClient.get(`/${workspace_id}/member-integrations/me`);

export type CreateMemberIntegration = {
  workspace_id: string;
  workspace_member_id: string;
  integration_id: string;
  provider: string;
  external_account_id: string | null;
  primary_email: string | null;
  is_active?: boolean;
  is_default_for_member?: boolean;
  options?: Record<string, any> | null;
};

export const createMemberIntegration = async ({
  workspace_id,
  workspace_member_id,
  integration_id,
  provider,
  external_account_id,
  primary_email,
  is_active = true,
  is_default_for_member = false,
  options = {},
}: CreateMemberIntegration) => authorizedApiClient.post(`/${workspace_id}/member-integrations`, {
  workspace_id,
  workspace_member_id,
  integration_id,
  provider,
  external_account_id,
  primary_email,
  is_active,
  is_default_for_member,
  options,
});

export type UpdateMemberIntegration = {
  workspace_id: string;
  id: string;
  external_account_id?: string | null;
  primary_email?: string | null;
  is_active?: boolean;
  is_default_for_member?: boolean;
  options?: Record<string, any> | null;
};

export const updateMemberIntegration = async ({
  workspace_id,
  id,
  external_account_id,
  primary_email,
  is_active,
  is_default_for_member,
  options,
}: UpdateMemberIntegration) => {
  const payload: any = { id };
  if (external_account_id !== undefined) payload.external_account_id = external_account_id;
  if (primary_email !== undefined) payload.primary_email = primary_email;
  if (is_active !== undefined) payload.is_active = is_active;
  if (is_default_for_member !== undefined) payload.is_default_for_member = is_default_for_member;
  if (options !== undefined) payload.options = options;

  return authorizedApiClient.patch(`/${workspace_id}/member-integrations/${id}`, payload);
};
